import React, { useState, useMemo } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import api from '../services/api';
import { soccerPath } from '../utils/paths';
import './Login.css';

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const tokenFromUrl = useMemo(() => searchParams.get('token') || '', [searchParams]);

  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (!tokenFromUrl.trim()) {
      setError('Missing reset token. Use the full link your admin sent you.');
      return;
    }
    if (newPassword.length < 6) {
      setError('Password must be at least 6 characters.');
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    setLoading(true);
    try {
      await api.resetPasswordWithToken({ token: tokenFromUrl.trim(), newPassword });
      setSuccess('Your password was updated. Redirecting to login…');
      setTimeout(() => navigate(soccerPath('/login'), { replace: true }), 2000);
    } catch (err) {
      setError(err.message || 'Could not reset password.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container" style={{ pointerEvents: loading ? 'none' : 'auto' }}>
      <div className="auth-card">
        <h2>Set a new password</h2>
        <p style={{ color: '#555', fontSize: '0.95rem', marginBottom: '1rem' }}>
          Choose a new password below. This page opens from a password reset link.
        </p>

        {!tokenFromUrl.trim() && (
          <div className="alert alert-error">
            No token in the URL. Use the link from your reset email or{' '}
            <Link to="/forgot-password">request a new one</Link>.
          </div>
        )}

        {error && <div className="alert alert-error">{error}</div>}
        {success && <div className="alert alert-success">{success}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="new-password">New password *</label>
            <input
              type="password"
              id="new-password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              minLength={6}
              autoComplete="new-password"
              placeholder="At least 6 characters"
              disabled={!tokenFromUrl.trim()}
            />
          </div>
          <div className="form-group">
            <label htmlFor="confirm-password">Confirm new password *</label>
            <input
              type="password"
              id="confirm-password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              minLength={6}
              autoComplete="new-password"
              placeholder="Repeat password"
              disabled={!tokenFromUrl.trim()}
            />
          </div>

          <button type="submit" className="btn btn-primary" disabled={loading || !tokenFromUrl.trim()}>
            {loading ? 'Saving…' : 'Update password'}
          </button>
        </form>

        <div className="auth-footer">
          <Link to={soccerPath('/login')}>Back to login</Link>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
